export default __webpack_public_path__ + "static/media/gap_logo.df03a944.png";